import Navigation from "./routes/Navigation";

function App() {
  return (
    <div>
      <Navigation />
    </div>
  );
}

export default App;
